import { HttpClientModule } from '@angular/common/http';
import { APP_INITIALIZER, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AnonymousAuthService, ClientAnonymousAuthModule } from '@thehubz/client/anonymous-auth';
import { CLIENT_USER_SESSION_KEY, ClientCoreModule, ENVIRONMENT, MatComponentsModule, USER_SESSION_TOKEN, UserSession } from '@thehubz/client/core';
import { ApiModule, Configuration } from '@thehubz/client/data-access-api';
import { Observable } from 'rxjs';
import { environment } from '../environments/environment';
import { CustomLayoutModule } from '../lib/layout/custom-layout.module';
import { CustomLoginModule } from '../lib/login/custom-login.module';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

function initializeAppFactory(authService: AnonymousAuthService): () => Observable<UserSession> {
  return () => authService.checkAndLoginAnonymously();
}

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    MatComponentsModule,
    AppRoutingModule,
    ApiModule,
    ClientCoreModule,
    ClientAnonymousAuthModule,
    CustomLayoutModule,
    CustomLoginModule,
  ],
  providers: [
    { provide: ENVIRONMENT, useValue: environment },
    { provide: USER_SESSION_TOKEN, useValue: CLIENT_USER_SESSION_KEY },
    {
      provide: Configuration,
      useFactory: () =>
        new Configuration({
          basePath: environment.apiBasePath,
        }),
      multi: false,
    },
    { provide: APP_INITIALIZER, useFactory: initializeAppFactory, deps: [AnonymousAuthService], multi: true },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
